<template>
  <div>
    <div class="error-update" v-if="errorUpdate">

    </div>
    <form v-else-if="form_steps.length > 0" @submit.prevent="validateBeforeSubmit">
      <p v-if="displayCurrentStep && form_steps[step].name" class="step">
        {{step + 1}}/{{form_steps.length}} <span v-html="form_steps[step].name"></span>
      </p>
      <p v-else-if="form_steps[step].name !== undefined" class="step" v-html="form_steps[step].name"></p>
      <p v-else-if="form_steps.length > 1" class="step">
        {{stepMessage}}{{step + 1}}/{{form_steps.length}}
      </p>
      <div v-for="(form_step, index_step) in form_steps" :key="index_step" class="form-step" :class="`form-step-${index_step}`">
        <template v-for="(field, index) in form_step.fields">
          <component
            :is="field.component"
            :key="index_step * 100 + index"
            v-if="(index_step === step || multiColumn) && displayIf(field) && field.component != 'ApiField'"
            v-bind="field"
            :validationRules="parseValidationRules(field)"
            :_id="form_id"
            :operationId="operationId"
            v-model="form[field.save_to]"
            :form="form"
            :locale="locale"
            :testmode="testmode"
            :googleMapsApiKey="googleMapsApiKey"
            :class="{filled: form[field.save_to] !== undefined && form[field.save_to] !== ''}"
          ></component>
        </template>
      </div>
      <p class="mention" v-if="required()">* {{$t('champ_obligatoire', this.locale)}}</p>
      <div class="captcha" v-show="is_last_step && recaptchaPublic"><div class="g-recaptcha" ref="recaptcha" :data-sitekey="recaptchaPublic"></div></div>
      <div class="builder-buttons">
        <button type="button" id="back_button" v-if="step > 0" @click="stepDown()"  v-html="buttonLabelPrecedent"></button>
        <input v-if="isIE" class="vue-loading-button" type="submit" :value="buttonLabel">
        <VueLoadingButton
          v-else-if="displayIf(bouton_text) && (bouton_text.hasSpinner || bouton_text.hasSpinner == undefined)"
          :loading="loading"
          type="sumbit"
          required="true"
          :class="{'valider': is_last_step, 'suivant': !is_last_step}"
        >{{buttonLabel}}</VueLoadingButton>
        <button v-else-if="displayIf(bouton_text)" type="submit" id="next_button" :class="{'valider': is_last_step || multiColumn, 'suivant': !is_last_step}" v-html="buttonLabel"></button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import inputComponents from '../input_components';
import i18n from './i18n';
import parseValidationRules from '../custom_rules/parseValidationRules';
import VueLoadingButton from 'vue-loading-button';
import track from './sessionTracking';
import fingerprint from './fingerprint';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const comp = { VueLoadingButton };
Object.entries(inputComponents).forEach(([key, val]) => (comp[key] = val));

export default {
  components: comp,
  mixins:[i18n.mixin],
  computed: {
    targets () {
      return this.$root.targets;
    },
    buttonLabelPrecedent() {
      if(this.bouton_text.precedent && this.bouton_text.precedent.length > 0) {
        return this.bouton_text.precedent
      } else {
        return this.$t('precedent', this.locale)
      }
    },
    buttonLabel() {
      if(this.is_last_step || this.multiColumn) {
        if(this.bouton_text.valider && this.bouton_text.valider.length > 0) {
          return this.bouton_text.valider;
        }else {
          return this.$t('valider', this.locale)
        }
      } else {
        if(this.bouton_text.suivant && this.bouton_text.suivant.length > 0) {
          return this.bouton_text.suivant;
        }else {
          return this.$t('suivant', this.locale)
        }
      }
    },
    is_last_step () {
      return this.step === this.form_steps.length - 1;
    },
  },
  data: function () {
    return {
      unique : false,
      isIE : false,
      form_steps: [],
      step: 0,
      percentCompleted: 0,
      recaptchaV3Public: undefined,
      recaptchaPublic: undefined,
      locale: 'fr',
      endpoint: '',
      googleMapsApiKey: '',
      errorUpdate: undefined,
      operationId: undefined,
      bouton_text: {
        valider: undefined,
        suivant: undefined,
        precedent: undefined,
        hasSpinner: false,
      },
      form: {
      },
      loading: false
    };
  },
  props: {
    server: {
      type: String,
      required: true
    },
    displayCurrentStep: Boolean,
    multiColumn: {
      type: Boolean,
      default: false,
    },
    form_id: {
      type: String,
      required: true
    },
    submission_id: {
      type: String,
    },
    stepMessage: {
      type: String,
      default: 'Étape '
    },
    relay: {
      type: Object,
    },
    testmode: {
      type: Object,
    },
    uid: {
      type: String,
    },
    hideError: {
      type: Boolean,
    }
  },
  provide () {
    return { parentValidator: this.$validator };
  },
  created() {
    this.$dayjs.extend(customParseFormat);
  },
  async mounted () {
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;

    this.endpoint = this.server + '/api/v2/submissions/' + this.form_id;

    try {
      const {data} = await axios.get(this.server + '/api/v2/formulaires/' + this.form_id);
      const {operation, formulaire} = data;
      if(this.relay) {
        console.log({relay: this.relay});
        for (let prop in this.relay) {
          this.form[prop] = this.relay[prop];
        }
      }
      if(formulaire.type == 'UPDATE') {
        await this.getSubmission();
      } else if (formulaire.type == 'LINE_ITEM'){
        this.form._id = this.submission_id;
      }

      this.createCaptchas(operation)
      this.googleMapsApiKey = operation.gmapkey;
      this.operationId = operation._id;
      if(data.lang != 'fr') {
        let localeMapVeeValidate = {
            'de': 'de',
            'es': 'es',
            'es-es': 'es',
            'nl': 'nl',
            'pl': 'pl',
            'it': 'it',
            'es-cat': 'es',
            'lu-nl': 'nl',
            'be-fr': 'fr',
            'en-uk': 'en',
            'uk': 'en',
            'en': 'en',
            'fr-fr': 'fr',
            'fr': 'fr',
            'lu-fr': 'fr',
            'be-nl': 'nl',
            'sl': 'sl',
            'si': 'sl',
            'bg': 'bg',
            'el': 'el',
            'gr': 'el',
        }
        this.locale = formulaire.lang || operation.lang;
        console.log("locale", this.locale)
        this.$validator.localize(localeMapVeeValidate[this.locale]);
      }
      Vue.set(this, 'bouton_text', formulaire.bouton_text || {})


      this.form_steps = formulaire.form;
      if (new Date() < operation.from) {
        this.$emit('too-early', operation.from);
        track('alert', 'too-early', {form_id: this.form_id, operation_id: this.operationId});
      } else if (new Date() > operation.to) {
        this.$emit('too-late', operation.to);
        track('alert', 'form-too-late', {form_id: this.form_id, operation_id: this.operationId});
      } else {
        track('action', 'display-form', {form_id: this.form_id, operation_id: this.operationId});
      }
    } catch (err) {
      console.error('error while loding form data:', err);
    }
  },
  methods: {
    displayIf(field) {
      if(field.displayIf && field.displayIf.length > 3) {
        try {
          return eval(field.displayIf)
        }catch(err) {
          console.error(err);
          return true;
        }
      } else {
        return true;
      }
    },
    async getSubmission() {
      if(!this.submission_id) {
        this.errorUpdate = 'No submission id';
      }
      try {
        let urlGetSubmission = this.server + '/api/v2/submissions/' + this.submission_id;
        if(this.uid) {
          urlGetSubmission = this.server + '/api/v2/submissions/' + this.submission_id + '?uid=' + this.uid;
        }
        const {data} = await axios.get(urlGetSubmission);
        this.form = data;
      } catch(err) {
        this.errorUpdate = `Submission ${this.submission_id} not found or bad uid`;
      }
    },
    parseValidationRules(field) {
      if(field.validation) {
        let rules = parseValidationRules(field.validation);
      } else {
        return {};
      }
    },
    createCaptchas(operation) {
      if(operation.recaptchaPublic || operation.recaptchaV3Public) {
        let recaptchaScript = document.createElement('script')
        let recaptchakey = operation.recaptchaV3Public || 'explicit'
        this.recaptchaPublic = operation.recaptchaPublic;
        this.recaptchaV3Public = operation.recaptchaV3Public;

        //Define onload recaptcha function
        if(this.recaptchaPublic) {
          window.onloadRecaptcha = () => {
            if(this.recaptchaPublic) {
              window.grecaptcha.render(
                this.$refs['recaptcha'], {
                  sitekey: this.recaptchaPublic
                }
              );
            }
          }
        } else {
          window.onloadRecaptcha = () => {
            //console.log("RecaptchaV3 loaded")
          }
        }
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=onloadRecaptcha&render=${recaptchakey}`)
        recaptchaScript.async = true;
        recaptchaScript.defer = true;
        document.head.appendChild(recaptchaScript)
      }
    },
    changeLocale() {
      this.locale = (this.locale == 'es')?'fr':'es';
      this.$validator.localize(this.locale);
    },
    validateAdress () {
      let adressField = this.form_steps[this.step].fields.find((field)=>{
        return field.component == "Adresse"
      })
      if(this.multiColumn && !adressField && this.form_steps[1]) {
        adressField = this.form_steps[1].fields.find((field)=>{
          return field.component == "Adresse"
        })
      }
      if(adressField == undefined || !adressField.required) {
        return true;
      }
      if(this.form[adressField.save_to].address == undefined) {
        if(window.gtag) {
          gtag('event', 'Form', {
            'event_category': 'Alert',
            'event_label': 'merci_renseigner_adresse',
          });
        }
        track('alert', 'merci_renseigner_adresse', {form_id: this.form_id, operation_id: this.operationId});
        alert(this.$t('merci_renseigner_adresse', this.locale));
        return false;
      } else {
        return true;
      }
    },
    stepUp () {
      if(this.validateAdress()) {
        this.step++;
        if(window.gtag) {
          gtag('event', 'Form', {
            'event_category': 'Step',
            'event_label':  `step_${this.step}`,
          });
        }
        track('action', 'step-up', {value: this.step, form_id: this.form_id, operation_id: this.operationId});
        this.$emit('step-up', this.step);
      }
    },
    stepDown () {
      this.step--;
      this.$emit('step-down', this.step);
      track('action', 'step-down', {value: this.step, form_id: this.form_id, operation_id: this.operationId});
    },
    required () {
      return this.form_steps.reduce((a, b) => a || (b.required !== false), false);// true if at least one field is required
    },
    validateBeforeSubmit () {
      if(!this.validateAdress()) {
        return;
      }

      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (!this.is_last_step && !this.multiColumn) {
            this.stepUp();
          } else {
            if(this.recaptchaPublic) {
              this.form.recaptcha = window.grecaptcha.getResponse();
            }
            if(this.recaptchaV3Public) {
              try {
                this.form.recaptchaV3 = await window.grecaptcha.execute(this.recaptchaV3Public, {action: 'register'});
              }catch(err) {
                console.error("Erreur domaine recaptcha v3");
                return alert("Erreur recaptcha v3");
              }
            }
            if (this.recaptchaPublic && this.form.recaptcha === '') {
              if(window.gtag) {
                gtag('event', 'Form', {
                  'event_category': 'Alert',
                  'event_label': 'captcha_invalide',
                });
              }
              track('alert', 'captcha_invalide', {form_id: this.form_id, operation_id: this.operationId});
              window.alert('Captcha invalide');
            } else {
              if(this.loading) {
                return;
              }
              this.loading = true;
              this.$emit('form_submit_loading', true);
              if(window.gtag) {
                gtag('event', 'Form', {
                  'event_category': 'Submit',
                  'event_label': this.form_id,
                });
              }
              track('action', 'form-submit', {form_id: this.form_id, operation_id: this.operationId});

              try {
                let res = await axios.put(this.endpoint, {...this.form,
                  url: window.location.href,
                  userAgent: window.navigator.userAgent,
                  windowInnerResolution: `${window.innerWidth}x${window.innerHeight}`,
                  fingerprint: fingerprint.get(),
                  testmode: this.testmode
                }, {
                  withCredentials: true,
                  crossDomain: true,
                  onUploadProgress: (progressEvent) => {
                    this.percentCompleted = Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.$emit('upload_progress', this.percentCompleted);
                  }
                })

                this.loading = false;
                this.$emit('form_submit_loading', false);
                this.$emit('results', res.data);
                if(window.gtag) {
                  gtag('event', 'Form', {
                    'event_category': 'Success',
                    'event_label': this.form_id,
                  });
                }
                track('result', 'form-success', {form_id: this.form_id, operation_id: this.operationId});

              } catch(err) {
                this.loading = false;
                this.$emit('form_submit_loading', false);
                this.step = 0;
                if(!this.hideError) {
                  alert(err);
                }
                if(err.response) {
                  this.$emit('on_error', err.response.data);
                } else {
                  this.$emit('on_error', "Erreur inconnue");
                }
                track('alert', 'form-error', {form_id: this.form_id, operation_id: this.operationId});
              }
            }
          }
        } else {
          alert(this.$t('Corrigez les erreurs', this.locale));
          if(window.gtag) {
            gtag('event', 'Form', {
              'event_category': 'Alert',
              'event_label': 'corrigez_les_erreurs',
            });
          }

          track('alert',
            'form-validation',
            {
              message: 'corrigez_les_erreurs',
              form_id: this.form_id,
              operation_id: this.operationId
            }
          );
        }
      });
    }
  }
  /*
  mounted () {
    const mapsScript = document.createElement('script');
    mapsScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBJ8R3BsCvNwNlcsjITn2IedKR8Y1Hvfzs&libraries=places');
    document.head.appendChild(mapsScript);
  } */
};
</script>
